const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");
const Icon = require("app/shared/components/Icon/icon");
const Tooltip = require("app/shared/components/Tooltip/tooltip");
const CenteredCardContent = require("../Dashboard/centered-card-content");

const Reflux = require("reflux");
const WinRateStore = require("../../stores/win-rate-store");
const WinRateActions = require("../../actions/win-rate-actions");

const textFormatter = require("app/util/formatter/text");
const currencyFormatter = require("app/util/formatter/currency");
const deltaCalculator = require("./util/delta-type");

const AnimatedValue = require("app/shared/components/AnimatedValue/animated-value");

const WinRateAmountWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return WinRateStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(WinRateStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    WinRateActions.fetchData(
      this.props.period,
      this.props.comparison,
      this.props.users,
      this.props.funnel
    );
  },

  helpTooltipText: function() {
    const wonAmount = currencyFormatter.formatCentsToCurrency(this.state.data.won.totalAmount);
    const lostAmount = currencyFormatter.formatCentsToCurrency(this.state.data.lost.totalAmount);
    const percentage = textFormatter.formatValuePercentage(this.state.data.totalAmountPercentage);

    let text = "É uma taxa de conversão que representa a proporção de ganhos em relação ao total de finalizados (ganhos + perdidos) no período. Nesse caso, considerando o valor dos negócios";

    text += "<br><br>Como no período houve <b>" + wonAmount + " ganhos</b> e <b>" + lostAmount + " perdidos</b>, a taxa de <b>" + percentage + "</b> ";
    text += "foi calculada usando a fórmula:<br>" + wonAmount + " / (" + wonAmount + " + " + lostAmount + ")";

    return text;
  },

  tooltipText: function() {
    const comparisonStart = this.props.period.startDate.format("DD MMM, YYYY");
    const comparisonEnd = this.props.period.endDate.format("DD MMM, YYYY");
    const comparison = `${comparisonStart} - ${comparisonEnd}`;

    const wonAmount = currencyFormatter.formatCentsToCurrency(this.state.data.won.totalAmount);
    const lostAmount = currencyFormatter.formatCentsToCurrency(this.state.data.lost.totalAmount);
    const ratio = textFormatter.formatValuePercentage(this.state.data.totalAmountPercentage);

    return `Como em ${comparison} houve <b>${wonAmount} ganhos</b> e <b>${lostAmount} perdidos</b>, a taxa <b>${ratio}</b> foi calculada usando a fórmula:<br>${wonAmount} / (${wonAmount} + ${lostAmount})`;
  },

  deltaTooltipText: function() {
    const comparisonStart = this.props.comparison.startDate.format("DD MMM, YYYY");
    const comparisonEnd = this.props.comparison.endDate.format("DD MMM, YYYY");
    const comparison = `${comparisonStart} - ${comparisonEnd}`;

    const noun = this.state.data.totalAmountPercentageDelta > 0 ? "Aumento" : "Redução";
    const value = textFormatter.formatValuePercentage(Math.abs(this.state.data.totalAmountPercentageDelta));

    return `${noun} de <b>${value}</b> comparado com a taxa em ${comparison}`;
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Taxa ganhos vs perdidos (valor)</p>
        }
        className="mh-265"
      >
        <Tooltip
          html
          title={this.helpTooltipText()}
          container="#tooltip-container"
        >
          <Icon custom icon="help-circle" className="c-fontGray"/>
        </Tooltip>
        <CenteredCardContent>
          <Summary
            big
            value={<AnimatedValue value={this.state.data.totalAmountPercentage} formatter={textFormatter.formatValuePercentage} precision={1} />}
            tooltipText={this.tooltipText()}
            delta={<AnimatedValue value={this.state.data.totalAmountPercentageDelta} formatter={textFormatter.formatValuePercentage} precision={1} />}
            deltaTooltipText={this.deltaTooltipText()}
            deltaType={deltaCalculator.deltaType(this.state.data.totalAmountPercentageDelta)}
          />
        </CenteredCardContent>
      </CardWithLoader>
    )
  }
});

module.exports = WinRateAmountWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/win-rate-amount-widget.jsx